import profile from "./LaunchWorkflows/profile.json";
import profilePaymentMethod from "./LaunchWorkflows/profilePaymentMethod.json";
import simTermination from "./LaunchWorkflows/simTermination.json";
import signUp from "./LaunchWorkflows/signUp.json";
import connectionDetails from "./LaunchWorkflows/connectionDetails.json";
import login from "./LaunchWorkflows/login.json";
import preCheckout from "./LaunchWorkflows/preCheckout.json";
import otpLogin from "./LaunchWorkflows/otpLogin.json";
import otpSignup from "./LaunchWorkflows/otpSignup.json";
import personalDetails from "./LaunchWorkflows/personalDetails.json";
import orderSummary from "./LaunchWorkflows/orderSummary.json";
import addonSelection from "./LaunchWorkflows/addonSelection.json";
import manageOrder from "./LaunchWorkflows/manageOrder.json";
import paymentSuccess from "./LaunchWorkflows/paymentSuccess.json";
import selectedPackages from "./LaunchWorkflows/selectedPackages.json";
import confirmEmail from "./LaunchWorkflows/confirmEmail.json";
import selectEmail from "./LaunchWorkflows/selectEmail.json";
import paymentQR from "./LaunchWorkflows/paymentQR.json";
import paymentFailed from "./LaunchWorkflows/paymentFailed.json";
import paymentPending from "./LaunchWorkflows/paymentPending.json";
import onboardingPaymentMethods from "./LaunchWorkflows/onboardingPaymentMethods.json";
import paymentCard from "./LaunchWorkflows/paymentCard.json";
import serviceRequests from "./LaunchWorkflows/serviceRequest.json";
import planSwitch from "./LaunchWorkflows/planSwitch.json";
import planSwitchDetails from "./LaunchWorkflows/planSwitchDetails.json";
import portInInstruction from "./LaunchWorkflows/portInInstruction.json";
import planSwitchOrderSummary from "./LaunchWorkflows/planSwitchOrderSummary.json";
import orderCancellation from "./LaunchWorkflows/orderCancellation.json";
import emailEdit from "./LaunchWorkflows/emailEdit.json";
import profileEmail from "./LaunchWorkflows/profileEmail.json";
import cancelPortin from "./LaunchWorkflows/cancelPortin.json";

/* All Launch workflow config import should be at the top */

/* Launch GlobalWorkflow config import starts */
import simActivationScan from "./LaunchGlobalWorkflows/simActivationScan.json";
import unsubscribe from "./LaunchGlobalWorkflows/unsubscribe.json";
import simActivationCode from "./LaunchGlobalWorkflows/simActivationCode.json";
import simVerificationPending from "./LaunchGlobalWorkflows/simVerificationPending.json";
import simActivationSuccess from "./LaunchGlobalWorkflows/simActivationSuccess.json";
import managePastServiceRequests from "./LaunchGlobalWorkflows/managePastServiceRequests.json";
// import manageSimReplacementOrderRequest from "./LaunchGlobalWorkflows/manageSimReplacementOrderRequest.json";
// import manageSimReplacementKyc from "./LaunchGlobalWorkflows/manageSimReplacementKyc.json";
// import manageSimReplacementIneligible from "./LaunchGlobalWorkflows/manageSimReplacementIneligible.json";
// import manageSimReplacementDeliveryDetails from "./LaunchGlobalWorkflows/manageSimReplacementDeliveryDetails.json";
// import manageSimReplacementOrderSummary from "./LaunchGlobalWorkflows/manageSimReplacementOrderSummary.json";
import manageServiceRequestStatus from "./LaunchGlobalWorkflows/manageServiceRequestStatus.json";
import manageUpdateCard from "./LaunchGlobalWorkflows/manageUpdateCard.json";
import manageManualEkyc from "./LaunchGlobalWorkflows/manageManualEkyc.json";
import orderlist from "./LaunchGlobalWorkflows/orderlist.json";
import manageServiceOrders from "./LaunchGlobalWorkflows/manageServiceOrders.json";
import manageReplaceSimEsimQr from "./LaunchGlobalWorkflows/manageReplaceSimEsimQr.json";
import scheduleDelivery from "./LaunchGlobalWorkflows/scheduleDelivery.json";
import manageChangeNumber from "./LaunchGlobalWorkflows/manageChangeNumber.json";
import payment from "./LaunchGlobalWorkflows/payment.json";
import paymentOutstandingBillPayment from "./LaunchGlobalWorkflows/paymentOutstandingBillPayment.json";
import paymentOutstandingBillsSuccess from "./LaunchGlobalWorkflows/paymentOutstandingBillsSuccess.json";
import paymentOutstandingBillsFail from "./LaunchGlobalWorkflows/paymentOutstandingBillsFail.json";
import paymentOutstandingBillsInProgress from "./LaunchGlobalWorkflows/paymentOutstandingBillsInProgress.json";
import manageCancelTerminationSuccess from "./LaunchGlobalWorkflows/manageCancelTerminationSuccess.json";
import manageSimActivation from "./LaunchGlobalWorkflows/manageSimActivation.json";
import manageSimActivationStatus from "./LaunchGlobalWorkflows/manageSimActivationStatus.json";
import manageSimActivationPending from "./LaunchGlobalWorkflows/manageSimActivationPending.json";
import manageSimActivationSuccess from "./LaunchGlobalWorkflows/manageSimActivationSuccess.json";
import cis from "./LaunchGlobalWorkflows/cis.json";
import profilePrivacySettings from "./LaunchGlobalWorkflows/profilePrivacySettings.json";
import manageReportLostSimCard from "./LaunchGlobalWorkflows/manageReportLostSimCard.json";
import paymentCardUpdate from "./LaunchGlobalWorkflows/paymentCardUpdate.json";
import shopOrderSummary from "./LaunchGlobalWorkflows/shopOrderSummary.json";
import shopPayment from "./LaunchGlobalWorkflows/shopPayment.json";
import identity from "./LaunchGlobalWorkflows/identity.json";
import loginweb from "./LaunchGlobalWorkflows/loginweb.json";
import manageReplaceSim from "./LaunchGlobalWorkflows/manageReplaceSim.json";
import manageReplaceSimSubmit from "./LaunchGlobalWorkflows/manageReplaceSimSubmit.json";
import managePaymentSuccess from "./LaunchGlobalWorkflows/managePaymentSuccess.json";
import managePaymentFailed from "./LaunchGlobalWorkflows/managePaymentFailed.json";
import paymentState from "./LaunchWorkflows/paymentState.json";

import simReplacementDelivery from "./LaunchWorkflows/sim-replacement/sim-replacement-delivery-uFone.json";
import simReplacementKyc from "./LaunchWorkflows/sim-replacement/sim-replacement-kyc.json";
import simReplacementOrderRequest from "./LaunchWorkflows/sim-replacement/sim-replacement-order-request.json";
import simReplacementOrderSummary from "./LaunchWorkflows/sim-replacement/sim-replacement-order-summary.json";
import simReplacementOrderStatus from "./LaunchWorkflows/sim-replacement/sim-replacement-order-status.json";
import simReplacementOrderPayment from "./LaunchWorkflows/sim-replacement/sim-replacement-order-payment.json";
import simReplacementIneligible from "./LaunchWorkflows/sim-replacement/sim-replacement-ineligible.json";

/* Onboarding flows */
import pendingOrders from "./LaunchWorkflows/onboarding/pendingOrders.json";
import pendingOrdersDetails from "./LaunchWorkflows/onboarding/pendingOrdersDetails.json";

/* Terms and conditions flow */
import privacyPolicy from "./LaunchWorkflows/terms-conditions/privacyPolicy.json";
import termsConditions from "./LaunchWorkflows/terms-conditions/general.json";

/*  Reschedule delivery flow config */
import rescheduleDelivery from "./LaunchWorkflows/reschedule-delivery/reschedule-delivery.json";
import rescheduleDeliveryPayment from "./LaunchWorkflows/reschedule-delivery/reschedule-delivery-payment.json";
import rescheduleDeliveryPaymentSuccess from "./LaunchWorkflows/reschedule-delivery/reschedule-delivery-payment-success.json";

/*  Launch General Application Configs starts*/
import countries from "./LaunchGeneralConfigs/countries.json";
import currency from "./LaunchGeneralConfigs/currency.json";
import delivery from "./LaunchGeneralConfigs/delivery.json";
import documents from "./LaunchGeneralConfigs/documents.json";
import generic from "./LaunchGeneralConfigs/generic.json";
import formValidations from "./LaunchGeneralConfigs/formValidations.json";
import themeColors from "./LaunchGeneralConfigs/themeColors.json";
import conditions from "./LaunchGeneralConfigs/conditions.json";
import layout from "./LaunchGeneralConfigs/layout.json";
import ui from "./LaunchGeneralConfigs/ui.json";
import promoCodeOffer from "./LaunchGeneralConfigs/promoCodeOffer.json";
import ekyc from "./LaunchGeneralConfigs/ekyc.json";
import formatting from "./LaunchGeneralConfigs/formatting.json";
import maintenance from "./LaunchGeneralConfigs/maintenance.json";
import profileConfig from "./LaunchGeneralConfigs/profile.json";
import plugins from "./LaunchGeneralConfigs/plugins.js";

export default {
  conditions,
  countries,
  currency,
  delivery,
  documents,
  formValidations,
  themeColors,
  layout,
  generic,
  ui,
  ekyc,
  plugins,
  promo_code_offer: promoCodeOffer,
  formatting,
  ...maintenance,
  profile: profileConfig,
  global: {
    workflow: [
      manageOrder,
      simActivationScan,
      simActivationCode,
      simVerificationPending,
      simActivationSuccess,
      managePastServiceRequests,
      simReplacementOrderRequest,
      simReplacementKyc,
      simReplacementIneligible,
      simReplacementDelivery,
      simReplacementOrderSummary,
      simReplacementOrderStatus,
      simReplacementOrderPayment,
      manageServiceRequestStatus,
      manageUpdateCard,
      manageManualEkyc,
      orderlist,
      manageServiceOrders,
      manageReplaceSimEsimQr,
      scheduleDelivery,
      manageChangeNumber,
      simTermination,
      rescheduleDelivery,
      rescheduleDeliveryPayment,
      rescheduleDeliveryPaymentSuccess,
      payment,
      paymentOutstandingBillPayment,
      paymentOutstandingBillsSuccess,
      paymentOutstandingBillsFail,
      paymentOutstandingBillsInProgress,
      manageCancelTerminationSuccess,
      manageSimActivation,
      manageSimActivationStatus,
      manageSimActivationPending,
      manageSimActivationSuccess,
      cis,
      profilePrivacySettings,
      manageReportLostSimCard,
      paymentCardUpdate,
      shopOrderSummary,
      shopPayment,
      identity,
      loginweb,
      manageReplaceSim,
      manageReplaceSimSubmit,
      managePaymentSuccess,
      managePaymentFailed
    ]
  },
  sim_replacement: { unused_doc_types: ["selfie"] },
  workflows: {
    default: "web",
    web: {
      workflow: [
        preCheckout,
        login,
        selectedPackages,
        addonSelection,
        signUp,
        otpLogin,
        otpSignup,
        confirmEmail,
        selectEmail,
        connectionDetails,
        personalDetails,
        orderSummary,
        paymentQR,
        paymentSuccess,
        paymentFailed,
        paymentPending,
        onboardingPaymentMethods,
        paymentCard,
        profile,
        serviceRequests,
        planSwitch,
        planSwitchDetails,
        planSwitchOrderSummary,
        orderCancellation,
        emailEdit,
        profileEmail,
        profilePaymentMethod,
        portInInstruction,
        cancelPortin,
        privacyPolicy,
        termsConditions,
        paymentState,
        pendingOrders,
        pendingOrdersDetails,
        unsubscribe,
        {
          components: [
            {
              data: { redirectUrl: "/manage/sim-activation" },
              enable: true,
              name: "BARCODE_SCANNER",
              scanned_field: "scanned_icc_id",
              scanning_field: false,
              showButton: false
            }
          ],
          name: "Scan sim's ICCID",
          path: "/manage/sim-scan"
        }
      ]
    }
  }
};
